export default __webpack_public_path__ + "locales/zh-CN/ChangeUserTypeDialog.json?hash=abe622f7fbf0955017eb26f043dad4aa";